import { render, staticRenderFns } from "./MessageButton.vue?vue&type=template&id=891d100c&scoped=true&"
import script from "./MessageButton.vue?vue&type=script&lang=ts&"
export * from "./MessageButton.vue?vue&type=script&lang=ts&"
import style0 from "./MessageButton.vue?vue&type=style&index=0&id=891d100c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891d100c",
  null
  
)

export default component.exports